<template>
  <div class="headinfo">
    <el-menu mode="horizontal" >
      <div id="logo" style="background: #0b9efe;" @click="getCollapse()">
        <div  class="logoImg"></div>
        <div  class="logoHoverImgClose"></div>
        <div  class="logoHoverImgOpen"></div>
      </div>
      <div style="vertical-align: middle">
        <el-breadcrumb separator="/" style="line-height: 60px">
          <el-breadcrumb-item id="homemenu" @click.native="goToPathUrl($store.state.Menu.path)">{{$store.getters.homeMenu}}</el-breadcrumb-item>
          <el-breadcrumb-item id="submenu">{{$store.getters.subMenu}}</el-breadcrumb-item>
        </el-breadcrumb>
        <header class="header">
          <ul class="nav">
            <li class="nav-item"><a class="el-icon customerService" target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3240489717&site=qq&menu=yes" style="width: 18px; height: 18px"></a></li>
            <el-popover ref="imgpopover" placement="bottom" trigger="hover">
              <img :src="imgHoverData.imgSrc" style="width:180px; height:180px;"></img>
            </el-popover>
            <!--<li class="nav-item"><i class="el-icon qrCode" v-popover:imgpopover  style="width: 18px; height: 18px"></i></li>-->
            <li class="nav-item systemMsg">
              <i class="el-icon news" style="width: 18px; height: 18px" @click="getSystemMessageList">
              </i>
            </li>
            <li class="nav-item">
              <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon userAvatar" style="width: 25px;height: 25px;"></i><span class="account">{{accountName}}</span><i class="el-icon-arrow-down"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="changePsd">修改密码</el-dropdown-item>
                  <el-dropdown-item @click.native="changeAcount" v-if="isChild">修改账号</el-dropdown-item>
                  <el-dropdown-item @click.native="showDoLogoutDialog">退出系统</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </header>
      </div>
    </el-menu>
    <dialogSystemMsg :messageList="messageList" dialogName="dialogSystemMsgShow"></dialogSystemMsg>
    <el-dialog class="dialogChangePsd" title="修改密码" :visible.sync="dialogChangePsdVisible">
      <el-form label-width="80px" label-position="top">
        <el-form-item label="旧密码" required class="required">
          <el-input v-model="theOldPwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码" required class="required">
          <el-input v-model="theNewPwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangePsdVisible = false" style="margin-right: 2px">取消</el-button>
        <el-button type="primary" @click="changePassword" >保存</el-button>
      </span>
    </el-dialog>
    <el-dialog class="dialogChangeAcount" title="修改账号" :visible.sync="dialogChangeAcountVisible">
      <el-form label-width="80px" label-position="top">
        <el-form-item label="当前登录手机" required class="required">
          <el-col :span='14'><el-input v-model="accountName"  :disabled="smsCodeBtnDisable" class='last-icon'></el-input></el-col>
          <el-col :span='10' class="getSMSCode"><el-button @click="getSMSCode()" type="text">{{sms_code_btn_title}}</el-button></el-col>
        </el-form-item>
        <el-form-item label="填写验证码" required class="required">
          <el-input v-model="smsCode" :maxlength="4"></el-input>
        </el-form-item>
        <el-form-item label="新手机号" required class="required">
          <el-col :span='14'><el-input v-model="newPhone" placeholder="请输入新手机号码" class='last-icon' :maxlength="11"></el-input></el-col>
          <el-col :span='10' class="getSMSCode"><el-button @click="getSMSCode2()" type="text">{{sms_code_btn_title2}}</el-button></el-col>
        </el-form-item>
        <el-form-item label="新手机号验证码" required class="required">
          <el-input v-model="code" :maxlength="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeAcountVisible = false" style="margin-right: 2px">取消</el-button>
        <el-button type="primary" @click="saveAcountInfo" >保存</el-button>
      </span>
    </el-dialog>

    <dialogContent :dialogContent="dialogContent" @submit="doLogout" ></dialogContent>
  </div>
</template>

<script>
  import http from "../../assets/js/http.js";
  import bus from '../../assets/js/bus'
  import cookie from '../../assets/js/cookie';
  import utils from '../../assets/js/utils';
  import validate from '../../assets/js/validate';
  import dialogContent from '../../components/dialog/dialogContent.vue';
  import dialogSystemMsg from '../../components/dialog/dialogSystemMsg.vue';
  import { mapState,mapGetters,mapMutations,mapActions } from 'vuex'
  export default {
    components: {
      http,dialogSystemMsg,dialogContent
    },
    data() {
      return {
        imgHoverData: {
          "imgSrc": "https://image.uzhujf.com/pms/img/icon/download.png"
        },
        accountName:"",
        winWidth:"",
        messageList:[],
        dialogChangePsdVisible:false,
        dialogChangeAcountVisible:false,
        theOldPwd:"",
        theNewPwd:"",
        dialogContent:{
          dialogVisible:'dialogDoLogoutVisible',//与子页面相关字符串,不可和其他页面一致
          title:'退出登录',//弹出框标题， str 例如“删除提示”  默认为 "提示"
          content:'是否要登出该账号?',//弹出框内容，str  例如 “确定删除该公寓图片?”
          confirm:'',//确认按钮文字内容， str  例如 “确认”  默认为 "确认"
          showIcon:true,
        },
        smsCodeBtnDisable:true,
        is_run: true,
        is_run2:true,
        sms_code_btn_title: '获取验证码',
        count_down: 60,
        sms_code_btn_title2: '获取验证码',
        count_down2: 60,
        newPhone:undefined,
        smsCode:undefined, //原账号接收的短信验证码
        code:undefined, //要修改手机接收的短信验证码
        isChild:undefined
      }
    },

    mounted(){
      this.accountName = decodeURI(cookie.getCookie("userName"));
      this.getCollapse();
      // this.$store.commit('loginSuccess');
      this.$nextTick(function () {
        this.whatEver()
      })
    },
    created(){
      var that = this;
    },
    computed: mapGetters({
      userName:"accountName",
      isLogin2:"isLogin",
    }),
    methods: {
      whatEver(){
        this.isChild = validate.checkMobile(this.accountName)
      },
      goToPathUrl(path){
        if(path != ''){
          this.$router.push({
            path: path,
          });
        }
      },
      changePsd(){
        var that = this;
        that.dialogChangePsdVisible = true
      },
      //修改账号
      changeAcount(){
        var that = this;
        that.dialogChangeAcountVisible = true
      },
      //获取原验证码
      getSMSCode(){
        var parameters = {
          accountName: this.accountName,  //账号
          smsType: "VM" //验证码类型
        };
        var that = this;
        if (that.is_run) {
          that.is_run = false;
          http.getSMSCode(that, parameters, function (response) {
              //请求成功,开始倒计时
            that.$message.success("验证码已发送");
            that.UISMSCode();
            }, function (response) {
              //请求失败恢复倒计时按钮点击
              that.is_run = true;
              that.$message.error(response.data.result);
            }
          );
        }
      },
      //获取新手机号验证码
      getSMSCode2(){
        var parameters = {
          accountName: this.newPhone,  //账号
          smsType: "CM" //验证码类型
        };
        if (parameters.accountName ==0 || validate.checkMobile(parameters.accountName) == false) {
          this.$message.error("请输入正确的手机号");
          return;
        }
        var that = this;
        if (that.is_run2) {
          that.is_run2 = false;
          http.getSMSCode(that, parameters, function (response) {
              //请求成功,开始倒计时
              that.$message.success("验证码已发送");
              that.UISMSCode2();
            }, function (response) {
              //请求失败恢复倒计时按钮点击
              that.is_run2 = true;
              that.$message.error(response.data.result);
            }
          );
        }
      },
      //验证码倒计时
      UISMSCode () {
        var that = this;
        if (this.count_down == 0) {
          //倒计时结束 重置状态
          this.sms_code_btn_title = '获取验证码';
          this.count_down = 60;
          this.is_run = true;
        } else {
          //倒计时开始
          this.sms_code_btn_title = '重新发送 ' + this.count_down;
          this.count_down--;

          //自动倒计时
          setTimeout(function () {
            that.UISMSCode();
          }, 1000);
        }
      },
      //验证码倒计时
      UISMSCode2 () {
        var that = this;
        if (this.count_down2 == 0) {
          //倒计时结束 重置状态
          this.sms_code_btn_title2 = '获取验证码';
          this.count_down2 = 60;
          this.is_run2 = true;
        } else {
          //倒计时开始
          this.sms_code_btn_title2 = '重新发送 ' + this.count_down2;
          this.count_down2--;

          //自动倒计时
          setTimeout(function () {
            that.UISMSCode2();
          }, 1000);
        }
      },
      //修改账号信息
      saveAcountInfo(){
        var that= this;
        var params = {
          "accountName":this.newPhone, //要修改的账号
          "smsCode":this.smsCode, //原账号接收的短信验证码
          "code":this.code //要修改手机接收的短信验证码
        };
        if (params.smsCode == undefined||params.smsCode.length==0) {
          that.$message.error("请输入验证码");
          return;
        } else if (params.accountName == undefined||params.accountName.length==0) {
          that.$message.error("请输入新手机号码");
          return;
        }else if (validate.checkMobile(params.accountName) == false) {
          this.$message.error("请输入正确的手机号");
          return;
        } else if (params.code == undefined||params.code.length==0) {
          that.$message.error("请输入新手机号验证码");
          return;
        }
        http.changeAccountName(that, params, function (response) {
          if(response.data.result!=undefined){
            that.$message.success("账号修改成功");
            that.dialogChangeAcountVisible = false;
            that.doLogout()
          }
        });
      },
      //修改密码
      changePassword: function () {
        var that = this;
        if (that.theOldPwd.length == 0) {
          that.$message.error("请输入原密码");
          return;
        } else if (validate.checkPassword(that.theOldPwd) == false) {
          that.$message.error("原密码由6至20位字母数字组合而成，区分大小写");
          return;
        } else if (that.theNewPwd.length == 0) {
          that.$message.error("请输入新密码");
          return;
        } else if (validate.checkPassword(that.theNewPwd) == false) {
          that.$message.error("新密码由6至20位字母数字组合而成，区分大小写");
          return;
        }
        var parameters = {
          theOldPwd: that.theOldPwd,
          theNewPwd: that.theNewPwd
        };
        http.changePassword(that, parameters, function () {
          that.$message.success("密码修改成功");
          that.dialogChangePsdVisible = false;
          that.theOldPwd = "";
          that.theNewPwd = "";
        });
      },
      showDoLogoutDialog(){
        this.$store.commit('showDialog',{
          dialogName:this.dialogContent.dialogVisible
        })
      },
      doLogout : function () {
        var that = this;
        localStorage.removeItem('menuList');
        that.$store.dispatch('logout',{
          page:that
        });
      },
      getCollapse(){
        var that = this;
        that.$store.commit('changeCollapse');
        if(that.$store.getters.isCollapse){
          clearTimeout(that.timer);
          that.timer = setTimeout(()=>{
            if(document.getElementById('container') != undefined){
              document.getElementById('container').style.marginLeft = '70px';
            }
            if(document.getElementsByClassName("logoImg")[0] != undefined){
              document.getElementsByClassName("logoImg")[0].style.margin = '7.5px 12.5px';
            }
            if(document.getElementsByClassName("logoHoverImgOpen")[0] != undefined){
              document.getElementsByClassName("logoHoverImgOpen")[0].style.margin = '7.5px 12.5px';
            }
            if(document.getElementsByClassName("logoHoverImgClose")[0] != undefined){
              document.getElementsByClassName("logoHoverImgClose")[0].style.margin = '7.5px 12.5px';
            }
          },200)
        } else {
          if(document.getElementById('container') != undefined){
            document.getElementById('container').style.marginLeft = '150px';
          }
          if(document.getElementsByClassName("logoImg")[0] != undefined){
            document.getElementsByClassName("logoImg")[0].style.margin = '7.5px 52.5px';
          }
          if(document.getElementsByClassName("logoHoverImgOpen")[0] != undefined){
            document.getElementsByClassName("logoHoverImgOpen")[0].style.margin = '7.5px 52.5px';
          }
          if(document.getElementsByClassName("logoHoverImgClose")[0] != undefined){
            document.getElementsByClassName("logoHoverImgClose")[0].style.margin = '7.5px 52.5px';
          }
        }
        document.getElementsByClassName("logoImg")[0].style.display = 'block';
        document.getElementsByClassName("logoHoverImgOpen")[0].style.display = 'none';
        document.getElementsByClassName("logoHoverImgClose")[0].style.display = 'none';
      },
      /**
       * 获取系统通知列表
       */
      getSystemMessageList: function () {
        var that = this;
        //请求公寓列表
        http.messageListIn7Days(that, {}, function (response) {
          var list = response.data.result;
          that.$store.commit('showDialog',{
            dialogName:"dialogSystemMsgShow"
          });
          if (list != undefined && list.length > 0) {
            that.isShowMessageRedPoint = true;
            that.messageList = list;
          } else {
            that.isShowMessageRedPoint = false;
            that.messageList = [];
          }
        });
      },
    }
  }
</script>
<style lang="scss" type="text/css">
  /*气泡样式*/
  .header .el-popover{
    width: 200px!important;
    padding: 15px
  }

  $breadcrumbColor:#999;
  .headinfo{
  #homemenu .el-breadcrumb__item__inner{
    color: $breadcrumbColor;
  }
  .el-breadcrumb__separator{
    color: $breadcrumbColor;
    margin: 0 15px;
  }
  #submenu .el-breadcrumb__item__inner{
    color: #333
  }
  .el-icon-arrow-down{
    color: #90a4ae;
  }
  .dialogChangePsd{
  .el-dialog{
    width: 400px;
  }
  }
  .getSMSCode{
    margin-top: 1px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    background: #f7f6f6;
    border: 1px solid #d3d3d3;
    border-left: 0;
  .el-button--text{
    color: #333;
  }
  }
  .last-icon{
  .el-input__inner{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  }
  }
</style>
<style lang="scss" scoped type="text/css">
  @import '../../assets/css/components/_icon.scss';
  $headinfoHeight:60px;
  $leftMenuWidth:180px;
  $headBackgroundColor:#fff;
  .customerService{
    background: url("../../assets/icons/top-qq.svg") no-repeat;
  }
  .qrCode{
    background: url("../../assets/icons/top-phone.svg") no-repeat;
  }
  .news{
    margin-top: -44px;
    background: url("../../assets/icons/top-news.svg") no-repeat;
  }
  .userAvatar{
    background: url("../../assets/icons/top-pic.svg") no-repeat;
  }
  ul.el-menu.el-menu--horizontal{
    position: fixed;
    top: 0;
    left: 0;
    height: $headinfoHeight;
    line-height: $headinfoHeight;
    display: -ms-flexbox;
    display: -webkit-box;
    z-index: 999;
    width: 100%;
    float: left;
    background:$headBackgroundColor;
    border-radius: 0;
    border-bottom: 0.5px solid #c8d1d3;
  #logo{
    cursor: pointer;
  }
  .logoImg{
    width: 45px;
    height: 45px;
    margin: $headinfoHeight / 8 52.5px;
    cursor: pointer;
    background: url("../../assets/icons/logoIcon.svg") no-repeat;
  }
  .logoHoverImgClose{
    width: 45px;
    height: 45px;
    margin: $headinfoHeight / 8 52.5px;
    cursor: pointer;
    background: url("../../assets/icons/top-left-arrow.svg") no-repeat;
  }
  .logoHoverImgOpen{
    width: 45px;
    height: 45px;
    margin: $headinfoHeight / 8 52.5px;
    cursor: pointer;
    background: url("../../assets/icons/top-right-arrow.svg") no-repeat;
  }
  .el-breadcrumb{
    font-size: 16px;
    padding-left: 15px;
    background: #fff;
  }
  }
  ul>.el-breadcrumb{
    line-height: $headinfoHeight;
  }
  .header{
    height: $headinfoHeight;
    line-height: $headinfoHeight;
    top: 0;
    right: 10px;
    position: fixed;
    width: auto;
    background: #fff;
    z-index: 9;


  .nav-item{
    margin: 0;
    float: left;
    list-style: none;
    position: relative;
    cursor: pointer;
    margin-left: 30px;
  .el-icon{
    color: #90a4ae;
    width: 16px;
    height: 16px;
  }
  }
  .systemMsg{
    margin-right: 29px;
    border-right: 1px solid #d6d6d6;
    height: 16px;
    margin-top: 22px;
    padding-right: 29px;
  }
  .account{
    margin: 0 10px;
    margin-left: 0;
    color: #999;
  }
  a:-webkit-any-link{
    text-decoration: none;
  }
  }
</style>



// WEBPACK FOOTER //
// headInfo.vue?19eb11b4